import React from 'react';
import { FloatingTooltip } from 'components/floating-tooltip/floating-tooltip';
import { formatNumber } from '../../utils/number';

interface TooltipDecimalProps {
  value?: number | null;
  isPercentage?: boolean;
  precision?: number;
}

const TooltipDecimal: React.FC<TooltipDecimalProps> = ({
  value,
  isPercentage = false,
  precision = 2,
}) => {
  const safeValue = value ?? 0;

  const displayValue = formatNumber({
    value: safeValue,
    minPrecision: precision,
    maxPrecision: precision,
    includeCommas: true,
  });

  const fullValue = safeValue.toString();

  const finalDisplay = isPercentage ? `${displayValue}%` : displayValue;
  const finalFullValue = isPercentage ? `${fullValue}%` : fullValue;

  return (
    <FloatingTooltip content={finalFullValue} placement="top">
      <span className="tooltip-decimal-content">{finalDisplay}</span>
    </FloatingTooltip>
  );
};

export default TooltipDecimal;
